import React, { CSSProperties } from "react";
import styled from "styled-components";

interface ContainerProps {
  className?: string;
  children?: React.ReactNode;
  size?: "es" | "sm" | "lite" | "md" | "lg";
  style?: CSSProperties;
}

const Container: React.FC<ContainerProps> = ({
  children,
  className,
  size = "md",
  style,
}) => {
  let width: number;
  switch (size) {
    case "es":
      width = 400;
      break;
    case "lite":
      width = 480;
      break;
    case "sm":
      width = 800;
      break;
    case "md":
      width = 1250;
      break;
    case "lg":
    default:
      width = 1500;
  }
  return (
    <StyledContainer className={className} width={width} style={{ ...style }}>
      {children}
    </StyledContainer>
  );
};

interface StyledContainerProps {
  width: number;
}

const StyledContainer = styled.div<StyledContainerProps>`
  box-sizing: border-box;
  margin: 0 auto;
  width: 90%;
`;

export default Container;
